import LegalLayout from "@/components/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" eyebrow="Legal · Anbieterkennzeichnung">
      <section className="space-y-10 text-white/80 font-body text-base leading-relaxed">

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Angaben gemäß § 5 TMG
          </h2>
          <p className="whitespace-pre-line">
{`VHP Consulting GmbH
Lützner Straße 214
04179 Leipzig
Deutschland`}
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Vertreten durch
          </h2>
          <p>Geschäftsführer: <span className="text-white">Matthias Kirchner</span></p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Kontakt
          </h2>
          <p className="whitespace-pre-line">
{`Telefon: +49 341 5502441
E-Mail:  kontakt@vhp-consulting.com
Web:     https://kirchero.store`}
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Registereintrag
          </h2>
          <p className="whitespace-pre-line">
{`Eintragung im Handelsregister
Registergericht: Amtsgericht Leipzig
Registernummer:  HRB 31253`}
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Marke „KirchHero"
          </h2>
          <p>
            Der Online-Shop unter <span className="text-white">kirchero.store</span> ist ein
            Angebot der VHP Consulting GmbH. „KirchHero" ist eine Marke und ein Geschäftsbereich
            der VHP Consulting GmbH.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Redaktionell verantwortlich (§ 18 Abs. 2 MStV)
          </h2>
          <p className="whitespace-pre-line">
{`Matthias Kirchner
Lützner Straße 214
04179 Leipzig`}
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            EU-Streitschlichtung
          </h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noreferrer"
              className="text-[#D4AF37] hover:underline"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
            . Unsere E-Mail-Adresse findest du oben im Impressum.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Verbraucher­streit­beilegung / Universal­schlichtungs­stelle
          </h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Haftung für Inhalte
          </h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch
            nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
            Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p className="mt-4">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
            der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Haftung für Links
          </h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss
            haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
            der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            Urheberrecht
          </h2>
          <p>
            Die durch den Seiten­betreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
            deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
            der VHP Consulting GmbH bzw. des jeweiligen Autors.
          </p>
        </div>

        <p className="text-white/40 text-xs">
          Stand: {new Date().toLocaleDateString("de-DE")}
        </p>
      </section>
    </LegalLayout>
  );
}
